import React from 'react'
import interceptedAxios from '../../../utils/interceptedAxios'

export class viewDeviceService {
  public static async viewDevice (deviceId: string): Promise<any> {
    const DeviceListUrl = `/assetrest/api/v2/udp/tiq/assets/${deviceId}`
    return await interceptedAxios.get(DeviceListUrl)
  }

  public static async getDeviceParamsConfig (deviceId: string, assetTypeId: string): Promise<any> {
    const modbusParametersUrl = `/asset-config-service/api/v1/udp/tiq/commands/configuration/asset/${deviceId}/paramconfig?assetTypeId=${assetTypeId}`
    return await interceptedAxios.get(modbusParametersUrl)
  }

  public static async getPerformanceIndicators (assetId: string, assetTypeId: string): Promise<any> {
    const getKpiUrl = `/asset-config-service/api/v1/udp/tiq/commands/configuration/asset/${assetId}/kpiconfig?assetTypeId=${assetTypeId}`
    return await interceptedAxios.get(getKpiUrl)
  }

  public static async getKpiAndParamsList (siteId: string, deviceId: string, deviceTypeId: string): Promise<any> {
    const getKpiUrl = `/asset-data-service/api/v1/udp/tiq/assets/data/register/configuration/${siteId}/${deviceId}/${deviceTypeId}`
    return await interceptedAxios.get(getKpiUrl)
  }

  public static async getKpiList (siteId: string, deviceId: string, deviceTypeId: string): Promise<any> {
    const getKpiUrl = `/kpirest/api/v1/udp/tiq/kpi/configuration/${siteId}/${deviceId}/${deviceTypeId}`
    return await interceptedAxios.get(getKpiUrl)
  }

  render (): any {
    return (
      <></>
    )
  }
}
